import {
  LandingPageHeaderContainer,
  LandingPageReportContainer,
} from 'containers/landing-page-container';
import { useEffect } from 'react';
import { useSettingsService } from 'services';
import { useSettingsStore } from 'store';
import './index.css';

const LandingPage = () => {
  const { fetchPayGapSign, fetchRtiTemplateToStore } = useSettingsService();

  useEffect(() => {
    const { isPayGapsPositive, rtiTemplateLoaded } = useSettingsStore.getState();
    if (isPayGapsPositive === null) {
      fetchPayGapSign();
    }
    if (!rtiTemplateLoaded) {
      fetchRtiTemplateToStore();
    }
  }, []);

  return (
    <div
      className='landing-page-container container flex flex-col justify-self-center'
      data-testid='landing-page-container'
    >
      <LandingPageHeaderContainer />
      <LandingPageReportContainer />
    </div>
  );
};
export default LandingPage;
